import { render } from "./base-notice-bar.vue?vue&type=template&id=bbb1377c"
const script = {}

import exportComponent from "/Users/blackend/Desktop/hay-gas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__